//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
import navigationComp from '~/components/help/navigation.vue' // 左侧导航
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'navigation-comp': navigationComp
  },
  asyncData ({ route }) {
    const arr = [
      'lang-help-instructions-for-using-vps.html',
      'lang-help-vps-product-classification.html',
      'lang-help-buy-vps-server-process.html',
      'lang-help-helpWin.html',
      'lang-help-helpMac.html',
      'lang-help-mt4-account-binding-process.html',
      'lang-help-mt5-account-binding-process.html',
      'lang-help-ctrader-account-binding-process.html'
    ]
    const activeIndex = arr.findIndex(item => item == route.name)
    return {
      activeIndex
    }
  },

  data () {
    return {
      content: {
        'zh-cn': `
        <div class="title-box">Mac如何连接VPS？</div>
                  <p>
                      <strong>第一步</strong>
                  </p>
                  <p>
                      打开WikiFX APP，进入【我的】-【我的VPS】获取您的主机IP、用户名和密码。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
                  </p>
                  <p>
                      <strong>第二步</strong>
                  </p>
                  <p>
                      安装Microsoft 远程桌面
                  </p>
                  <ul>
                      <li>
                          <p>
                            • 打开 App Store 搜索“microsoft remote desktop” 安装 Microsoft 远程桌面应用程序
                          </p>
                      </li>
                      <li>
                          <p class="m0">
                            • 通过下面的链接下载Microsoft 远程桌面应用程序
                          </p>
                      </li>
                  </ul>
                  <p>
                      <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
                  </p>
                  <ul>
                      <li>
                          <p class="m0">
                            • 如果您所在的地区App Store 商店不支持安装 Microsoft 远程桌面应用程序，请点击
                          </p>
                      </li>
                  </ul>
                  <p>
                      <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
                  </p>
                  <p>
                      <strong>第三步</strong>
                  </p>
                  <p>
                      安装应用程序后单击“打开”，打开后单击“添加 PC ”：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
                  </p>
                  <p>
                      <strong>第四步</strong>
                  </p>
                  <p>
                      在PC 名称字段中输入主机 IP，并单击Add
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
                  </p>
                  <p>
                      <strong>第五步</strong>
                  </p>
                  <p>
                      双击新的连接条目以连接到您的 WikiFX VPS，然后您将被要求提供您的 VPS 凭据（EA VPS的登录账户名、登录密码）
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
                  </p>
                  <p>
                      <strong>第六步</strong>
                  </p>
                  <p>
                      您将收到证书警告。点击“继续”：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
                  </p>
                  <p>
                      此时您应该能看到 Windows 桌面，这就是您的WikiFX VPS 桌面
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
                  </p>`,
        zh: `
        <div class="title-box">Mac如何連接VPS？</div>
            <p>
                第一步
            </p>
            <p>
                開啟WikiFX APP，進入【我的】-【我的VPS】取得您的主機IP、使用者名稱和密碼。
            </p>
            <p class="m30">
              <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
            </p>
            <p>
                第二步
            </p>
            <p>
                安裝Microsoft 遠端桌面
            </p>
            <ul>
                <li>
                    <p>
                        • 開啟 App Store 搜尋「microsoft remote desktop」 安裝 Microsoft 遠端桌面應用程式
                    </p>
                </li>
                <li>
                    <p class="m0">
                        • 透過下面的連結下載Microsoft 遠端桌面應用程式
                    </p>
                </li>
            </ul>
            <p>
                <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
            </p>
            <ul>
                <li>
                    <p class="m0">
                        • 如果您所在的地區App Store 商店不支援安裝 Microsoft 遠端桌面應用程序，請點擊
                    </p>
                </li>
            </ul>
            <p>
                <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
            </p>
            <p class="m30">
              <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
            </p>
            <p>
                第三步
            </p>
            <p>
                安裝應用程式後點擊“打開”，打開後點擊“新增 PC ”：
            </p>
            <p class="m30">
              <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
            </p>
            <p>
                第四步
            </p>
            <p>
                在PC 名稱欄位中輸入主機 IP，並按一下Add
            </p>
            <p class="m30">
              <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
            </p>
            <p>
                第五步
            </p>
            <p>
                雙擊新的連線項目以連接到您的 WikiFX VPS，然後您將被要求提供您的 VPS 憑證（EA VPS的登入帳號、登入密碼）
            </p>
            <p class="m30">
              <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
            </p>
            <p>
                第六步
            </p>
            <p>
                您將收到證書警告。 點選“繼續”：
            </p>
            <p class="m30">
              <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
            </p>
            <p>
                此時您應該可以看到 Windows 桌面，這就是您的WikiFX VPS 桌面
            </p>
            <p class="m30">
              <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
            </p>`,
        en: `
        <div class="title-box">How to connect to VPS on Mac?</div>
              <p>
                  first step
              </p>
              <p>
                  Open WikiFX APP, go to [My]-[My VPS] to get your host IP, username and password.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Step 2
              </p>
              <p>
                  Install Microsoft Remote Desktop
              </p>
              <ul>
                  <li>
                      <p>
                          • Open the App Store and search for &quot;Microsoft Remote Desktop&quot; to install the Microsoft Remote Desktop application.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • Download the Microsoft Remote Desktop application via the link below
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • If the App Store in your region does not support installing the Microsoft Remote Desktop application, please click
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  third step
              </p>
              <p>
                  Click &quot;Open&quot; after installing the application, and click &quot;Add PC&quot; after opening:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  the fourth step
              </p>
              <p>
                  Enter the host IP in the PC name field and click Add
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  the fifth step
              </p>
              <p>
                  Double-click the new connection entry to connect to your WikiFX VPS, you will then be asked to provide your VPS credentials (EA VPS login name, login password)
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Step 6
              </p>
              <p>
                  You will receive a certificate warning. Click &quot;Continue&quot;:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  At this point you should see the Windows desktop, this is your WikiFX VPS desktop
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        ru: `
        <div class="title-box">Как подключиться к VPS на Mac?</div>
              <p>
                  первый шаг
              </p>
              <p>
                  Откройте приложение WikiFX, перейдите в раздел [Мой]-[Мой VPS], чтобы получить IP-адрес вашего хоста, имя пользователя и пароль.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Шаг 2
              </p>
              <p>
                  Установите удаленный рабочий стол Microsoft.
              </p>
              <ul>
                  <li>
                      <p>
                          • Откройте App Store и найдите «Microsoft Remote Desktop», чтобы установить приложение Microsoft Remote Desktop.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • Загрузите приложение Microsoft Remote Desktop по ссылке ниже.
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • Если App Store в вашем регионе не поддерживает установку приложения Microsoft Remote Desktop, нажмите
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  третий шаг
              </p>
              <p>
                  Нажмите «Открыть» после установки приложения и нажмите «Добавить компьютер» после открытия:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  четвертый шаг
              </p>
              <p>
                  Введите IP-адрес хоста в поле имени компьютера и нажмите «Добавить».
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  пятый шаг
              </p>
              <p>
                  Дважды щелкните новую запись подключения, чтобы подключиться к вашему WikiFX VPS, после чего вам будет предложено предоставить учетные данные вашего VPS (имя для входа в EA VPS, пароль для входа).
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Шаг 6
              </p>
              <p>
                  Вы получите предупреждение о сертификате. Нажмите «Продолжить»:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  На этом этапе вы должны увидеть рабочий стол Windows, это ваш рабочий стол WikiFX VPS.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        ja: `
        <div class="title-box">Mac で VPS に接続するにはどうすればよいですか?</div>
              <p>
                  最初の一歩
              </p>
              <p>
                  WikiFX アプリを開き、[My]-[My VPS] に移動してホスト IP、ユーザー名、パスワードを取得します。
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  ステップ2
              </p>
              <p>
                  Microsoft リモート デスクトップをインストールする
              </p>
              <ul>
                  <li>
                      <p>
                          • App Store を開いて「Microsoft リモート デスクトップ」を検索し、Microsoft リモート デスクトップ アプリケーションをインストールします。
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • 以下のリンクから Microsoft リモート デスクトップ アプリケーションをダウンロードします。
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • お住まいの地域の App Store が Microsoft リモート デスクトップ アプリケーションのインストールをサポートしていない場合は、クリックしてください。
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  第三段階
              </p>
              <p>
                  アプリケーションをインストールしたら「開く」をクリックし、開いたら「PC を追加」をクリックします。
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  4番目のステップ
              </p>
              <p>
                  「PC名」フィールドにホストIPを入力し、「追加」をクリックします。
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  5番目のステップ
              </p>
              <p>
                  新しい接続エントリをダブルクリックして WikiFX VPS に接続すると、VPS 認証情報 (EA VPS ログイン名、ログイン パスワード) を入力するように求められます。
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  ステップ6
              </p>
              <p>
                  証明書の警告が表示されます。 「続行」をクリックします。
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  この時点で、Windows デスクトップが表示されます。これが WikiFX VPS デスクトップです。
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        th: `
        <div class="title-box">จะเชื่อมต่อกับ VPS บน Mac ได้อย่างไร?</div>
              <p>
                  ขั้นแรก
              </p>
              <p>
                  เปิดแอป WikiFX ไปที่ [ของฉัน]-[VPS ของฉัน] เพื่อรับ IP โฮสต์ ชื่อผู้ใช้ และรหัสผ่านของคุณ
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  ขั้นตอนที่ 2
              </p>
              <p>
                  ติดตั้ง Microsoft Remote Desktop
              </p>
              <ul>
                  <li>
                      <p>
                          • เปิด App Store และค้นหา &quot;Microsoft Remote Desktop&quot; เพื่อติดตั้งแอปพลิเคชัน Microsoft Remote Desktop
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • ดาวน์โหลดแอปพลิเคชัน Microsoft Remote Desktop ผ่านลิงก์ด้านล่าง
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • หาก App Store ในภูมิภาคของคุณไม่รองรับการติดตั้งแอปพลิเคชัน Microsoft Remote Desktop โปรดคลิก
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  ขั้นตอนที่สาม
              </p>
              <p>
                  คลิก &quot;เปิด&quot; หลังจากติดตั้งแอปพลิเคชัน และคลิก &quot;เพิ่มพีซี&quot; หลังจากเปิด:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  ขั้นตอนที่สี่
              </p>
              <p>
                  ป้อน IP โฮสต์ในช่องชื่อพีซีแล้วคลิกเพิ่ม
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  ขั้นตอนที่ห้า
              </p>
              <p>
                  คลิกสองครั้งที่รายการการเชื่อมต่อใหม่เพื่อเชื่อมต่อกับ WikiFX VPS ของคุณ จากนั้นคุณจะถูกขอให้ระบุข้อมูลประจำตัว VPS ของคุณ (ชื่อเข้าสู่ระบบ EA VPS รหัสผ่านเข้าสู่ระบบ)
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  ขั้นตอนที่ 6
              </p>
              <p>
                  คุณจะได้รับคำเตือนใบรับรอง คลิก &quot;ดำเนินการต่อ&quot;:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  ณ จุดนี้ คุณควรเห็นเดสก์ท็อป Windows นี่คือเดสก์ท็อป WikiFX VPS ของคุณ
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        vi: `
        <div class="title-box">Làm cách nào để kết nối với VPS trên Mac?</div>
              <p>
                  bước đầu tiên
              </p>
              <p>
                  Mở APP WikiFX, đi tới [My]-[My VPS] để lấy IP máy chủ, tên người dùng và mật khẩu của bạn.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Bước 2
              </p>
              <p>
                  Cài đặt máy tính từ xa của Microsoft
              </p>
              <ul>
                  <li>
                      <p>
                          • Mở App Store và tìm kiếm &quot;Microsoft Remote Desktop&quot; để cài đặt ứng dụng Microsoft Remote Desktop.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • Tải ứng dụng Microsoft Remote Desktop qua link dưới đây
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • Nếu App Store ở khu vực bạn không hỗ trợ cài đặt ứng dụng Microsoft Remote Desktop, vui lòng nhấn vào
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  bước thứ ba
              </p>
              <p>
                  Nhấp vào &quot;Mở&quot; sau khi cài đặt ứng dụng và nhấp vào &quot;Thêm PC&quot; sau khi mở:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  bước thứ tư
              </p>
              <p>
                  Nhập IP máy chủ vào trường tên PC và nhấp vào Thêm
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  bước thứ năm
              </p>
              <p>
                  Bấm đúp vào mục kết nối mới để kết nối với VPS WikiFX của bạn, sau đó bạn sẽ được yêu cầu cung cấp thông tin đăng nhập VPS của mình (tên đăng nhập EA VPS, mật khẩu đăng nhập)
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Bước 6
              </p>
              <p>
                  Bạn sẽ nhận được một cảnh báo chứng chỉ. Nhấp vào &quot;Tiếp tục&quot;:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  Tại thời điểm này, bạn sẽ thấy màn hình Windows, đây là màn hình VPS WikiFX của bạn
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        id: `
        <div class="title-box">Bagaimana cara terhubung ke VPS di Mac?</div>
              <p>
                  Langkah pertama
              </p>
              <p>
                  Buka APLIKASI WikiFX, buka [Saya]-[VPS Saya] untuk mendapatkan IP host, nama pengguna, dan kata sandi Anda.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Langkah 2
              </p>
              <p>
                  Instal Microsoft Desktop Jarak Jauh
              </p>
              <ul>
                  <li>
                      <p>
                          • Buka App Store dan cari &quot;Microsoft Remote Desktop&quot; untuk menginstal aplikasi Microsoft Remote Desktop.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • Download aplikasi Microsoft Remote Desktop melalui link dibawah ini
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • Jika App Store di wilayah Anda tidak mendukung instalasi aplikasi Microsoft Remote Desktop, silakan klik
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  langkah ketiga
              </p>
              <p>
                  Klik &quot;Buka&quot; setelah menginstal aplikasi, dan klik &quot;Tambah PC&quot; setelah membuka:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  langkah keempat
              </p>
              <p>
                  Masukkan IP host di bidang nama PC dan klik Tambah
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  langkah kelima
              </p>
              <p>
                  Klik dua kali entri koneksi baru untuk terhubung ke VPS WikiFX Anda, Anda kemudian akan diminta untuk memberikan kredensial VPS Anda (nama login EA VPS, kata sandi login)
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Langkah 6
              </p>
              <p>
                  Anda akan menerima peringatan sertifikat. Klik &quot;Lanjutkan&quot;:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  Pada titik ini Anda akan melihat desktop Windows, ini adalah desktop VPS WikiFX Anda
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        es: `
        <div class="title-box">¿Cómo conectarse a VPS en Mac?</div>
              <p>
                  primer paso
              </p>
              <p>
                  Abra la APLICACIÓN WikiFX, vaya a [Mi]-[Mi VPS] para obtener la IP de su host, su nombre de usuario y su contraseña.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Paso 2
              </p>
              <p>
                  Instalar escritorio remoto de Microsoft
              </p>
              <ul>
                  <li>
                      <p>
                          • Abra la App Store y busque &quot;Microsoft Remote Desktop&quot; para instalar la aplicación Microsoft Remote Desktop.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • Descargue la aplicación Microsoft Remote Desktop a través del siguiente enlace
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • Si la App Store de su región no admite la instalación de la aplicación Microsoft Remote Desktop, haga clic en
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  tercer paso
              </p>
              <p>
                  Haga clic en &quot;Abrir&quot; después de instalar la aplicación y haga clic en &quot;Agregar PC&quot; después de abrirla:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  el cuarto paso
              </p>
              <p>
                  Ingrese la IP del host en el campo de nombre de la PC y haga clic en Agregar
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  el quinto paso
              </p>
              <p>
                  Haga doble clic en la nueva entrada de conexión para conectarse a su VPS WikiFX; luego se le pedirá que proporcione sus credenciales de VPS (nombre de inicio de sesión de EA VPS, contraseña de inicio de sesión)
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Paso 6
              </p>
              <p>
                  Recibirá una advertencia de certificado. Haga clic en &quot;Continuar&quot;:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  En este punto deberías ver el escritorio de Windows, este es tu escritorio VPS WikiFX.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        hi: `
        <div class="title-box">मैक पर वीपीएस से कैसे जुड़ें?</div>
              <p>
                  पहला कदम
              </p>
              <p>
                  WikiFX ऐप खोलें, अपना होस्ट आईपी, उपयोगकर्ता नाम और पासवर्ड प्राप्त करने के लिए [My]-[My VPS] पर जाएं।
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  चरण दो
              </p>
              <p>
                  माइक्रोसॉफ्ट रिमोट डेस्कटॉप स्थापित करें
              </p>
              <ul>
                  <li>
                      <p>
                          • ऐप स्टोर खोलें और माइक्रोसॉफ्ट रिमोट डेस्कटॉप एप्लिकेशन इंस्टॉल करने के लिए &quot;माइक्रोसॉफ्ट रिमोट डेस्कटॉप&quot; खोजें।
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • नीचे दिए गए लिंक के माध्यम से माइक्रोसॉफ्ट रिमोट डेस्कटॉप एप्लिकेशन डाउनलोड करें
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • यदि आपके क्षेत्र का ऐप स्टोर माइक्रोसॉफ्ट रिमोट डेस्कटॉप एप्लिकेशन इंस्टॉल करने का समर्थन नहीं करता है, तो कृपया क्लिक करें
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  तीसरा चरण
              </p>
              <p>
                  एप्लिकेशन इंस्टॉल करने के बाद &quot;ओपन&quot; पर क्लिक करें, और खोलने के बाद &quot;पीसी जोड़ें&quot; पर क्लिक करें:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  चौथा चरण
              </p>
              <p>
                  पीसी नाम फ़ील्ड में होस्ट आईपी दर्ज करें और जोड़ें पर क्लिक करें
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  पाँचवाँ चरण
              </p>
              <p>
                  अपने WikiFX VPS से कनेक्ट करने के लिए नई कनेक्शन प्रविष्टि पर डबल-क्लिक करें, फिर आपसे अपना VPS क्रेडेंशियल (EA VPS लॉगिन नाम, लॉगिन पासवर्ड) प्रदान करने के लिए कहा जाएगा।
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  चरण 6
              </p>
              <p>
                  आपको एक प्रमाणपत्र चेतावनी प्राप्त होगी. &quot;जारी रखें&quot; पर क्लिक करें:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  इस बिंदु पर आपको विंडोज़ डेस्कटॉप देखना चाहिए, यह आपका विकीएफएक्स वीपीएस डेस्कटॉप है
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        fil: `
        <div class="title-box">Paano kumonekta sa VPS sa Mac?</div>
              <p>
                  unang hakbang
              </p>
              <p>
                  Buksan ang WikiFX APP, pumunta sa [My]-[My VPS] para makuha ang iyong host IP, username at password.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Hakbang 2
              </p>
              <p>
                  I-install ang Microsoft Remote Desktop
              </p>
              <ul>
                  <li>
                      <p>
                          • Buksan ang App Store at hanapin ang &quot;Microsoft Remote Desktop&quot; upang i-install ang Microsoft Remote Desktop application.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • I-download ang Microsoft Remote Desktop application sa pamamagitan ng link sa ibaba
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • Kung ang App Store sa iyong rehiyon ay hindi sumusuporta sa pag-install ng Microsoft Remote Desktop application, mangyaring mag-click
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  ikatlong hakbang
              </p>
              <p>
                  I-click ang &quot;Buksan&quot; pagkatapos i-install ang application, at i-click ang &quot;Magdagdag ng PC&quot; pagkatapos buksan:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  ang ikaapat na hakbang
              </p>
              <p>
                  Ipasok ang host IP sa field ng PC name at i-click ang Add
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  ang ikalimang hakbang
              </p>
              <p>
                  I-double-click ang bagong entry ng koneksyon upang kumonekta sa iyong WikiFX VPS, hihilingin sa iyo na ibigay ang iyong mga kredensyal sa VPS (pangalan sa pag-log in sa EA VPS, password sa pag-login)
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Hakbang 6
              </p>
              <p>
                  Makakatanggap ka ng babala sa sertipiko. I-click ang &quot;Magpatuloy&quot;:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  Sa puntong ito dapat mong makita ang Windows desktop, ito ang iyong WikiFX VPS desktop
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        fr: `
        <div class="title-box">Comment se connecter à un VPS sur Mac ?</div>
              <p>
                  premier pas
              </p>
              <p>
                  Ouvrez l&#39;application WikiFX, accédez à [Mon]-[Mon VPS] pour obtenir votre adresse IP hôte, votre nom d&#39;utilisateur et votre mot de passe.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Étape 2
              </p>
              <p>
                  Installer le Bureau à distance Microsoft
              </p>
              <ul>
                  <li>
                      <p>
                          • Ouvrez l&#39;App Store et recherchez « Microsoft Remote Desktop » pour installer l&#39;application Microsoft Remote Desktop.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • Téléchargez l&#39;application Microsoft Remote Desktop via le lien ci-dessous
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • Si l&#39;App Store de votre région ne prend pas en charge l&#39;installation de l&#39;application Microsoft Remote Desktop, veuillez cliquer sur
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  troisième étape
              </p>
              <p>
                  Cliquez sur « Ouvrir » après avoir installé l&#39;application, puis cliquez sur « Ajouter un PC » après l&#39;ouverture :
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  la quatrième étape
              </p>
              <p>
                  Entrez l&#39;adresse IP de l&#39;hôte dans le champ Nom du PC et cliquez sur Ajouter
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  la cinquième étape
              </p>
              <p>
                  Double-cliquez sur la nouvelle entrée de connexion pour vous connecter à votre VPS WikiFX, il vous sera alors demandé de fournir vos informations d&#39;identification VPS (nom de connexion EA VPS, mot de passe de connexion)
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Étape 6
              </p>
              <p>
                  Vous recevrez un avertissement de certificat. Cliquez sur &quot;Continuer&quot;&nbsp;:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  À ce stade, vous devriez voir le bureau Windows, il s&#39;agit de votre bureau WikiFX VPS
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        de: `
        <div class="title-box">Wie verbinde ich mich mit VPS auf dem Mac?</div>
              <p>
                  erster Schritt
              </p>
              <p>
                  Öffnen Sie die WikiFX-App, gehen Sie zu [Mein] – [Mein VPS], um Ihre Host-IP, Ihren Benutzernamen und Ihr Passwort zu erhalten.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Schritt 2
              </p>
              <p>
                  Installieren Sie Microsoft Remote Desktop
              </p>
              <ul>
                  <li>
                      <p>
                          • Öffnen Sie den App Store und suchen Sie nach „Microsoft Remote Desktop“, um die Microsoft Remote Desktop-Anwendung zu installieren.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • Laden Sie die Microsoft Remote Desktop-Anwendung über den untenstehenden Link herunter
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • Wenn der App Store in Ihrer Region die Installation der Microsoft Remote Desktop-Anwendung nicht unterstützt, klicken Sie bitte
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  dritter Schritt
              </p>
              <p>
                  Klicken Sie nach der Installation der Anwendung auf „Öffnen“ und nach dem Öffnen auf „PC hinzufügen“:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  der vierte Schritt
              </p>
              <p>
                  Geben Sie die Host-IP in das Feld „PC-Name“ ein und klicken Sie auf „Hinzufügen“.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  der fünfte Schritt
              </p>
              <p>
                  Doppelklicken Sie auf den neuen Verbindungseintrag, um eine Verbindung zu Ihrem WikiFX-VPS herzustellen. Anschließend werden Sie aufgefordert, Ihre VPS-Anmeldeinformationen anzugeben (EA-VPS-Anmeldename, Anmeldekennwort).
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Schritt 6
              </p>
              <p>
                  Sie erhalten eine Zertifikatswarnung. Klicken Sie auf „Weiter“:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  An dieser Stelle sollten Sie den Windows-Desktop sehen. Dies ist Ihr WikiFX VPS-Desktop
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        pt: `
        <div class="title-box">Como se conectar ao VPS no Mac?</div>
              <p>
                  Primeiro passo
              </p>
              <p>
                  Abra o APP WikiFX, vá para [Meu]-[Meu VPS] para obter seu IP de host, nome de usuário e senha.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Passo 2
              </p>
              <p>
                  Instale a Área de Trabalho Remota da Microsoft
              </p>
              <ul>
                  <li>
                      <p>
                          • Abra a App Store e pesquise “Microsoft Remote Desktop” para instalar o aplicativo Microsoft Remote Desktop.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • Baixe o aplicativo Microsoft Remote Desktop através do link abaixo
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • Se a App Store da sua região não oferecer suporte à instalação do aplicativo Microsoft Remote Desktop, clique em
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  terceiro passo
              </p>
              <p>
                  Clique em &quot;Abrir&quot; após instalar o aplicativo e clique em &quot;Adicionar PC&quot; após abrir:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  o quarto passo
              </p>
              <p>
                  Insira o IP do host no campo Nome do PC e clique em Adicionar
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  o quinto passo
              </p>
              <p>
                  Clique duas vezes na nova entrada de conexão para conectar-se ao seu WikiFX VPS, então você será solicitado a fornecer suas credenciais VPS (nome de login do EA VPS, senha de login)
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Etapa 6
              </p>
              <p>
                  Você receberá um aviso de certificado. Clique em &quot;Continuar&quot;:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  Neste ponto você deverá ver a área de trabalho do Windows, esta é a sua área de trabalho WikiFX VPS
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        tr: `
        <div class="title-box">Mac'te VPS'ye nasıl bağlanılır?</div>
              <p>
                  ilk adım
              </p>
              <p>
                  WikiFX APP&#39;yi açın, ana bilgisayar IP&#39;nizi, kullanıcı adınızı ve şifrenizi almak için [Benim]-[VPS&#39;im]&#39;e gidin.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  Adım 2
              </p>
              <p>
                  Microsoft Uzak Masaüstü&#39;nü yükleyin
              </p>
              <ul>
                  <li>
                      <p>
                          • Microsoft Uzak Masaüstü uygulamasını yüklemek için App Store&#39;u açın ve &quot;Microsoft Uzak Masaüstü&quot; ifadesini arayın.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • Aşağıdaki bağlantıdan Microsoft Uzak Masaüstü uygulamasını indirin
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • Bölgenizdeki App Store Microsoft Uzak Masaüstü uygulamasının yüklenmesini desteklemiyorsa lütfen tıklayın
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  üçüncü adım
              </p>
              <p>
                  Uygulamayı yükledikten sonra &quot;Aç&quot;a tıklayın ve açtıktan sonra &quot;Bilgisayar Ekle&quot;ye tıklayın:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  dördüncü adım
              </p>
              <p>
                  Ana bilgisayar IP&#39;sini PC adı alanına girin ve Ekle&#39;ye tıklayın.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  beşinci adım
              </p>
              <p>
                  WikiFX VPS&#39;nize bağlanmak için yeni bağlantı girişine çift tıklayın, ardından VPS kimlik bilgilerinizi (EA VPS oturum açma adı, oturum açma şifresi) sağlamanız istenecektir.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  Adım 6
              </p>
              <p>
                  Sertifika uyarısı alacaksınız. &quot;Devam Et&quot;i tıklayın:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  Bu noktada Windows masaüstünü görmelisiniz, bu sizin WikiFX VPS masaüstünüzdür
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        ko: `
        <div class="title-box">Mac에서 VPS에 어떻게 연결하나요?</div>
              <p>
                  첫 번째 단계
              </p>
              <p>
                  WikiFX 앱을 열고 [내]-[내 VPS]로 이동하여 호스트 IP, 사용자 이름 및 비밀번호를 받으세요.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  2 단계
              </p>
              <p>
                  Microsoft 원격 데스크톱 설치
              </p>
              <ul>
                  <li>
                      <p>
                          • App Store를 열고 &quot;Microsoft Remote Desktop&quot;을 검색하여 Microsoft Remote Desktop 애플리케이션을 설치하세요.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • 아래 링크를 통해 Microsoft 원격 데스크톱 애플리케이션을 다운로드하세요.
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • 해당 지역의 App Store가 Microsoft 원격 데스크톱 애플리케이션 설치를 지원하지 않는 경우 다음을 클릭하세요.
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  세 번째 단계
              </p>
              <p>
                  애플리케이션을 설치한 후 &quot;열기&quot;를 클릭하고, 연 후 &quot;PC 추가&quot;를 클릭합니다.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  네 번째 단계
              </p>
              <p>
                  PC 이름 필드에 호스트 IP를 입력하고 추가를 클릭합니다.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  다섯 번째 단계
              </p>
              <p>
                  새 연결 항목을 두 번 클릭하여 WikiFX VPS에 연결하면 VPS 자격 증명(EA VPS 로그인 이름, 로그인 비밀번호)을 제공하라는 메시지가 표시됩니다.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  6단계
              </p>
              <p>
                  인증서 경고를 받게 됩니다. &quot;계속&quot;을 클릭하세요:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  이제 Windows 바탕 화면이 표시됩니다. 이것이 WikiFX VPS 바탕 화면입니다.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`,
        ar: `
        <div class="title-box">كيفية الاتصال بـ VPS على ماك؟</div>
              <p>
                  الخطوة الأولى
              </p>
              <p>
                  افتح تطبيق WikiFX، وانتقل إلى [My] - [My VPS] للحصول على عنوان IP للمضيف واسم المستخدم وكلمة المرور.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon1.png')}"/>
              </p>
              <p>
                  الخطوة 2
              </p>
              <p>
                  قم بتثبيت Microsoft Remote Desktop
              </p>
              <ul>
                  <li>
                      <p>
                          • افتح متجر التطبيقات وابحث عن &quot;Microsoft Remote Desktop&quot; لتثبيت تطبيق Microsoft Remote Desktop.
                      </p>
                  </li>
                  <li>
                      <p class="m0">
                          • قم بتنزيل تطبيق Microsoft Remote Desktop عبر الرابط أدناه
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" href="https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12" class="link">https://apps.apple.com/us/app/microsoft-remote-desktop/id1295203466?mt=12</a>
              </p>
              <ul>
                  <li>
                      <p class="m0">
                          • إذا كان متجر التطبيقات في منطقتك لا يدعم تثبيت تطبيق Microsoft Remote Desktop، فيرجى النقر فوق
                      </p>
                  </li>
              </ul>
              <p>
                  <a target="_blank" class="link" href="https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac">https://install.appcenter.ms/orgs/rdmacios-k2vy/apps/microsoft-remote-desktop-for-mac/distribution_groups/all-users-of-microsoft-remote-desktop-for-mac</a>
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon2.png')}"/>
              </p>
              <p>
                  خطوة ثالثة
              </p>
              <p>
                  انقر فوق &quot;فتح&quot; بعد تثبيت التطبيق، ثم انقر فوق &quot;إضافة جهاز كمبيوتر&quot; بعد فتحه:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon3.png')}"/>
              </p>
              <p>
                  الخطوة الرابعة
              </p>
              <p>
                  أدخل عنوان IP المضيف في حقل اسم الكمبيوتر وانقر فوق &quot;إضافة&quot;.
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon4.png')}"/>
              </p>
              <p>
                  الخطوة الخامسة
              </p>
              <p>
                  انقر نقرًا مزدوجًا فوق إدخال الاتصال الجديد للاتصال بـ WikiFX VPS الخاص بك، سيُطلب منك بعد ذلك تقديم بيانات اعتماد VPS الخاصة بك (اسم تسجيل الدخول إلى EA VPS، كلمة مرور تسجيل الدخول)
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon5.png')}"/>
              </p>
              <p>
                  الخطوة 6
              </p>
              <p>
                  سوف تتلقى تحذير الشهادة. انقر فوق &quot;متابعة&quot;:
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon6.png')}"/>
              </p>
              <p>
                  في هذه المرحلة، يجب أن تشاهد سطح مكتب Windows، وهذا هو سطح مكتب WikiFX VPS الخاص بك
              </p>
              <p class="m30">
                <img src="${require('~/assets/img/help/mac-icon7.png')}"/>
              </p>`
      }
    }
  },
  head () {
    return {
      title: this.$t('22979'),
      meta: [
        { name: 'Description', content: this.$t('22980') }
      ]
    }
  }
}
